import React from "react";
import { Image } from "react-bootstrap";
import { Game } from "@nestcoinco/hyper-api-gateway-api-client";

import "./DesktopShareTrayModal.scss";
import BottomSheet from "../../BottomSheet/BottomSheet";
import GhostButton from "../../dashboard-page/GhostButton/GhostButton";
import CloseIcon from "../../icons/CloseIcon";
import ImageWhatsapp from "../../../images/whatsapp-with-bg.png";
import ImageX from "../../../images/x-with-bg.png";
import ImageTelegram from "../../../images/telegram-with-bg.png";
import ImageFacebook from "../../../images/facebook-with-bg.png";
import { LINKS } from "../../../utils/constants";
import CopyIcon from "../../icons/CopyIcon";
import { GenericModalProps } from "../../../utils/constants/generic-types";
import { copyToClipboard } from "../../../utils/helpers";

const SOCIALS = {
  WHATSAPP: "whatsapp",
  TELEGRAM: "community",
  FACEBOOK: "facebook",
  X: "twitter",
};

const imageMap = {
  [SOCIALS.FACEBOOK]: ImageFacebook,
  [SOCIALS.TELEGRAM]: ImageTelegram,
  [SOCIALS.X]: ImageX,
  [SOCIALS.WHATSAPP]: ImageWhatsapp,
};

const linkMap = {
  [SOCIALS.FACEBOOK]: LINKS.WEBPAGE.FACEBOOK,
  [SOCIALS.TELEGRAM]: LINKS.SOCIAL.TELEGRAM,
  [SOCIALS.X]: LINKS.WEBPAGE.X,
  [SOCIALS.WHATSAPP]: LINKS.SOCIAL.WHATSAPP,
};

function SocialLink({ platform }: { platform: string }) {
  const imageSrc = imageMap[platform] || ImageWhatsapp;
  const href = linkMap[platform] || LINKS.SOCIAL.WHATSAPP;

  return (
    <a href={href} target="_blank" rel="noreferrer" className="social-link">
      <Image src={imageSrc} height={60} width={60} alt="" />
      <span className="text mt-1">{platform}</span>
    </a>
  );
}

function DesktopShareTrayModal({
  isOpen,
  onClose,
  link,
  game,
}: GenericModalProps & { link: string; game?: Game }) {
  return (
    <BottomSheet isOpen={isOpen}>
      <div className="desktop-share-tray-modal">
        <div className="header d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-2">
            <Image src={game?.thumbnail} height={40} width={40} />
            <div>
              <p className="game-name">{game?.name}</p>
              <p className="game-link">{link}</p>
            </div>
          </div>
          <GhostButton className="close-btn" onClick={onClose}>
            <CloseIcon stroke="#3C3C43" />
          </GhostButton>
        </div>

        <div className="d-flex justify-content-between px-3 mt-4">
          {/* TODO: Fetch social URLs from BE after merge */}
          <SocialLink platform={SOCIALS.WHATSAPP} />
          <SocialLink platform={SOCIALS.FACEBOOK} />
          <SocialLink platform={SOCIALS.X} />
          <SocialLink platform={SOCIALS.TELEGRAM} />
        </div>

        <div className="px-3 mt-5">
          <div className="copy-box">
            <p className="text">Copy Link</p>
            <GhostButton onClick={() => copyToClipboard(link)}>
              <CopyIcon fill="#7E43FF" height={20} width={20} />
            </GhostButton>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
}

export default DesktopShareTrayModal;
